// extracted by mini-css-extract-plugin
module.exports = {"container":"XrqG8erC_GRtyr7wvcqfn","fieldsWrapper":"Qdcx7clh0vGV6bMdixQlE","requiredLabel":"-B-DdjGmZIAhtALflIkYL","limitWrapper":"_24Wl76xBYYldJbn4g_QQ_E"};